<mat-toolbar color="primary" >
  <mat-toolbar-row>
    <button type="button" mat-button (click)="drawer.toggle()">
      <mat-icon *ngIf="!drawer.opened" style="color: white"> menu </mat-icon>
      <mat-icon *ngIf="drawer.opened" style="color: white"> close </mat-icon>
    </button>
    <a class="nav-top-bar-logo-link" [routerLink]="'/home'">

      <img src="{{imgLogo}}" alt="logoExplorandes" />

    </a>
    <span class="example-spacer"></span>

    <a style="color: white;text-decoration: none" routerLink="" (click)="signOut()" >Salir</a>
  </mat-toolbar-row>
</mat-toolbar>


<mat-drawer-container class="example-container" autosize>
  <mat-drawer #drawer [(opened)]="matchesTemp" class="example-sidenav" [mode]="mobileQuery.matches ? 'over' : 'side'" >
        <mat-nav-list *ngFor="let item of menuData">
          <span style="font-weight: bold;font-size: medium;padding-right: 30px">{{item.menu}}</span>
          <hr>
          <a *ngFor="let sub of item.subMenu" mat-list-item [routerLink]="sub.route">
            <mat-icon >{{sub.icon}} </mat-icon>
            <span style="font-size: 15px">{{sub.name}}</span>
          </a>
        </mat-nav-list>
  </mat-drawer>

  <div *ngIf="isTokenReady">
    <router-outlet></router-outlet>
  </div>

</mat-drawer-container>

